import React from 'react';
import NavigationPanel from '../shared/NavigationPanel/NavigationPanel';
import { store } from '../../stores/store';
import { toast } from 'react-toastify';
import { useFetchReportList } from '../shared/NavigationPanel/ReportsAPIHook/useFetchReportList';
import { IFavoriteReport, IMemorizedReport } from '../shared/NavigationPanel/ReportsAPIHook/reportTypes';

const NavigationPanelDemo: React.FC = () => {

  const reportId: number | undefined = 194;
  const userId: number | undefined = store.commonStore.userId ?? undefined;
  const holderId: number | undefined = store.commonStore.departmentId ?? undefined;

  // Fetch favorite reports
  const {
    reportList: favoriteReportList,
    loading: isFavoriteLoading,
    error: favoriteError,
  } = useFetchReportList<IFavoriteReport>({
    apiUrl: userId
      ? `${process.env.REACT_APP_REPORT_API_URL}favoritereports?userId=${userId}`
      : undefined,
    reportId,
    type: 'favorite',
    body: undefined  //demo
  });

  // Fetch memorized reports
  const {
    reportList: memorizedReportList,
    loading: isMemorizedLoading,
    error: memorizedError,
  } = useFetchReportList<IMemorizedReport>({
    apiUrl: userId && reportId && holderId
      ? `${process.env.REACT_APP_REPORT_API_URL}memorizedreports?userId=${userId}&reportId=${reportId}&holderId=${holderId}`
      : undefined,
    reportId,
    type: 'memorized',
    body: undefined //demo
  });

  // Helper to construct custom URLs
  const getCustomURL = (customURL: string): string => {
    if (customURL && customURL.trim() !== '') {
      return customURL.includes('.asp')
        ? `${process.env.REACT_APP_QSIGHT_URL}${customURL.replace(window.location.origin, '')}`
        : `${customURL}?key=${store.commonStore.redisKey}`;
    }
    return `${process.env.REACT_APP_QSIGHT_URL}report_view.asp`;
  };

  // Map favorite reports
  const mappedFavoriteReports = (favoriteReportList ?? [])
    .filter((fav: IFavoriteReport) => fav.reportID !== reportId)
    .map((fav: IFavoriteReport) => ({
      id: fav.reportID,
      name: fav.reportName,
      url: getCustomURL(fav.customURL),
    }));

  // Map memorized reports
  const mappedCustomReports = (memorizedReportList ?? []).map((report: IMemorizedReport) => ({
    id: report.memorizedReportId,
    name: report.savedName,
    url: `${report.customURL}?key=${store.commonStore.redisKey}&memid=${report.memorizedReportId}`
  }));

  // Handle loading state
  if (isFavoriteLoading || isMemorizedLoading) {
    return <p>Loading...</p>;
  }

  // Handle error state
  if (favoriteError || memorizedError) {
    toast.error('Oops! Something went wrong while fetching the report list. Please try again later or contact support if the issue persists.');
  }

  return (
    <div>
      <NavigationPanel
        customReports={mappedCustomReports}
        favoriteReports={mappedFavoriteReports}
        customTitle={'Usage Transfer'}
      />
    </div>
  );
};

export default NavigationPanelDemo;
